<main class="container mh-100">
  <div class="w-100 overflow-hidden position-relative" id="section1">
    <div class="container-fluid position-relative page-content">
      <div class="row">
        <div class="col-12 col-lg-6 d-flex mh-100 align-items-center">
          <div class="m-4 w-100">
            <!--<h1 class="bg-dark d-inline">Bonjour,</h1>
            <div class="clear-both"></div>
            <p class="lead bg-dark d-inline">je suis Quentin, un designer/developer</p>-->
            <img src="/assets/img/intro-01.svg" style="width: 100%; height: auto" alt="Bonjour, je suis Quentin un designer/developer" class="mb-2">
            
            <div class="clear-both mt-4"></div>
            <a (click)="reloadHome()" class="btn btn-outline-secondary d-block  mb-2">Nouveau design <i class="ico">🎨</i></a>
            <a (click)="nextSection(1)" class="btn btn-outline-secondary d-block  mb-2">Suivant &darr;</a>
            <!--<a routerLink="/contact" class="btn btn-light d-block  mb-2">Contact</a>-->
            <!--<a href="https://instagram.com/quentinlemonnier/" target="_blank" class="btn btn-light d-block mb-2">@quentinlemonnier</a>-->
            
          </div>
        </div>
        <div class="col-12 col-lg-6 d-none d-lg-flex mh-100 align-items-center">
          <img src="/assets/img/vousici-01.svg" alt="" style="width: 100%; height: auto;">
        </div>

      </div>
    </div>
  </div>
</main>

<div class="container" data-section="1" id="projects">
  <div class="w-100 mh-100 overflow-hidden position-relative" id="section4">
    <div class="row position-relative page-content">
      <div class="col-12 col-lg-12 d-flex mh-100 align-items-center">
        <div class="m-4 w-100">
          <p class="display-4 text-white bg-primary d-inline p-2 text-break">Projets</p>
          <!--<p class="pt-5 text-break">Réalisations : </p>-->
          <ul class="list-inline pt-5">
            <li class="list-inline-item m-2"><a routerLink="/project/gargantua-chinon" class="badge badge-pill badge-secondary p-2">Gargantua-Chinon.fr</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/artefactspace" class="badge badge-pill badge-secondary p-2">Artefact.space</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/apenti" class="badge badge-pill badge-secondary p-2">Apenti</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/pokemon" class="badge badge-pill badge-secondary p-2">Pokémon</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/clarapoe" class="badge badge-pill badge-secondary p-2">Clara Poe</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/artefact" class="badge badge-pill badge-secondary p-2">Artefact</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/paint" class="badge badge-pill badge-secondary p-2">Paint-98</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/mise-en-scene" class="badge badge-pill badge-secondary p-2">Mise en scène</a></li>
          </ul>
          <ul class="list-inline pt-2">
            <li class="list-inline-item m-2"><a routerLink="/project/estimeo" class="badge badge-pill badge-secondary p-2">Estimeo</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/singlespot" class="badge badge-pill badge-secondary p-2">Singlespot</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/lebipe" class="badge badge-pill badge-secondary p-2">Le BIPE</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/lebipe/fnc" class="badge badge-pill badge-secondary p-2">FNC</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/dt" class="badge badge-pill badge-secondary p-2">Domaine de Touraine</a></li>
            <li class="list-inline-item m-2"><a routerLink="/project/RAM" class="badge badge-pill badge-secondary p-2">Royal Air Maroc</a></li>
          </ul>
          <a (click)="nextSection(2)" class="btn btn-outline-secondary d-block  mb-2">Suivant &darr;</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container" data-section="2" id="skills">
  <div class="w-100 mh-100 overflow-hidden position-relative" id="section2">
    <div class="row position-relative page-content">
      <div class="col-12 col-lg-12 d-flex mh-100 align-items-center">
        <div class="m-4 w-100">
          <div class="o-hidden w-100">
            <p class="display-4 text-white bg-primary d-inline p-2 text-break">Le &lt;code/&gt; comme outil de design</p>
          </div>
          <p class="pt-5 mb-0">Compétences techniques : </p>
          <ul class="list-inline pt-2">
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">HTML5/CSS3</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">JavaScript</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Angular 2+</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">TypeScript</span>
            </li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Jasmine & Karma</span>
            </li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Bootstrap</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">MongoDB</span>
            </li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Node.js</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Express.js</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">PHP</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">MYSQL</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">WordPress</span></li>
          </ul>
          <p class="pt-2 mb-0">Compétences graphiques : </p>
          <ul class="list-inline pt-2">
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Adobe Xd</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Adobe Illustrator</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Adobe Photoshop</span></li>
            <li class="list-inline-item m-2"><span class="badge badge-pill badge-dark">Adobe Indesign</span></li>
          </ul>
          <a (click)="nextSection(3)" class="btn btn-outline-secondary d-block  mb-2">Suivant &darr;</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container" data-section="3" id="about">
  <div class="w-100 mh-100 overflow-hidden position-relative" id="section4">
    <div class="row position-relative page-content">
      <div class="col-12 col-lg-12 d-flex mh-100 align-items-center">
        <div class="m-4 w-100">
          <p class="display-4 text-white bg-primary d-inline p-2 text-break">&Agrave; propos</p>
          <p class="pt-5 text-break">Autodidacte en développement web, j'ai suivi un cursus en design graphique et une licence en gestion de projet web afin de faire le pont entre création et code.</p>
          <p class="text-break">Fort d'une expérience en agence de publicité (<a routerLink="/project/singlespot" class="text-secondary">Singlespot</a>) et dans le conseil en stratégie d'entreprise (<a routerLink="/project/lebipe" class="text-secondary">Le BIPE</a>), j'ai travaillé auprès de grands comptes pour la réalisation de leurs projets digitaux.</p>
          <p class="text-break">Au sein d'<a routerLink="/project/estimeo" class="text-secondary">Estimeo</a>, j'ai été en charge de concevoir et réaliser les interfaces visibles par les utilisateurs.</p>
          <p class="text-break">Depuis février 2022, j'exerce dans une entreprise française éditant un outil Saas de cyber-sécurité.</p>

          <button class="btn btn-outline-secondary d-block mb-2 text-break" disabled style="width: 100%; display: block;">bonjour[at]quentinlemonnier.fr ✉️</button>
          <a routerLink="/timeline" class="btn btn-outline-secondary d-block mb-2">Timeline 🚀</a>
          <a routerLink="/project/resume" class="btn btn-outline-secondary d-block mb-2">Curriculum vitae 🧠</a>
          <!--<a routerLink="/contact" class="btn btn-secondary d-block  mb-2">Contact <i class="ico">🚀</i></a>-->
          <a (click)="firstSection()" class="btn btn-outline-secondary d-block  mb-5">Haut de page &uarr;</a>
        </div>
      </div>
    </div>
  </div>
</div>